
// import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
// import { Infinity, TrendingUp, ArrowRight, Check, Clock, FileText, Flame } from "lucide-react";
// import Sidebar from "../../component/sidebar/sidebar";
// import hamburgerIcon from "../../Asset/Hamburger.svg";

// // ─── Mock data – swap with real API response ─────────────────────────────────
// const MOCK_DATA = {
//     isPro: true, // API: true = Pro view, false = Free view
//     userName: "John Doe",
//     weeklyTimeSaved: { hours: 8, minutes: 12 },
//     transcription: {
//         used: 6.5,
//         total: null,          // null = unlimited (Pro) | number = cap (Free)
//         resetsOn: "Nov 16",
//         planLabel: "ZT Pro",  // "Free Plan" for free users
//     },
//     stats: {
//         dailyTimeSaved: "4h 48m",
//         wordsTranscribed: "12.8k",
//         currentStreak: "7 days",
//     },
//     devices: [
//         { name: "Android", audioMin: 45.6 },
//         { name: "Web", audioMin: 35.1 },
//         { name: "Windows", audioMin: 8.8 },
//         { name: "iOS", audioMin: 0.9 },
//     ],
// };

// const PRO_FEATURES = [
//     "Unlimited words per week",
//     "Advanced AI features",
//     "Unlimited audio transcription",
//     "Export in multiple formats",
// ];

// // ─── Stat Card ────────────────────────────────────────────────────────────────
// const StatCard = ({ label, value, icon: Icon, iconBg, iconColor }) => (
//     <div
//         className="flex items-center gap-3 flex-1 min-w-0 bg-white"
//         style={{
//             borderRadius: "12.1px",
//             border: "1.51px solid #0000000D",
//             padding: "0 20px",
//             height: "65px",
//         }}
//     >
//         {/* Colored circle icon */}
//         <div
//             style={{
//                 width: "36px",
//                 height: "36px",
//                 borderRadius: "50%",
//                 background: iconBg,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//             }}
//         >
//             <Icon size={17} color={iconColor} strokeWidth={2.2} />
//         </div>

//         <span
//             style={{
//                 fontFamily: "Poppins, sans-serif",
//                 fontWeight: 500,
//                 fontSize: "18.14px",
//                 lineHeight: "29.48px",
//                 letterSpacing: "-0.14px",
//                 color: "#000000",
//                 whiteSpace: "nowrap",
//             }}
//         >
//             {label}
//         </span>
//         <span
//             style={{
//                 fontFamily: "Poppins, sans-serif",
//                 fontWeight: 600,
//                 fontSize: "18.14px",
//                 lineHeight: "31.75px",
//                 letterSpacing: "0.06px",
//                 color: "#000000",
//                 whiteSpace: "nowrap",
//             }}
//         >
//             {value}
//         </span>
//     </div>
// );

// // ─── Progress Bar ─────────────────────────────────────────────────────────────
// const UsageBar = ({ used, total }) => {
//     const pct = total ? Math.min((used / total) * 100, 100) : 100;
//     return (
//         <div
//             className="w-full rounded-full overflow-hidden"
//             style={{ height: "12px", background: "#E5E7EB" }}
//         >
//             <div
//                 className="h-full rounded-full"
//                 style={{
//                     width: `${pct}%`,
//                     background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
//                     transition: "width 0.7s ease",
//                 }}
//             />
//         </div>
//     );
// };

// // ─── Main Component ───────────────────────────────────────────────────────────
// const Usage = () => {
//     const [openSidebar, setOpenSidebar] = useState(true);
//     const [openSidebarMobile, setOpenSidebarMobile] = useState(false);

//     // Replace MOCK_DATA with your API response
//     const data = MOCK_DATA;
//     const { isPro, userName, weeklyTimeSaved, transcription, stats, devices } = data;

//     const maxDeviceMin = Math.max(...devices.map((d) => d.audioMin), 1);

//     return (
//         <>
//             <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');`}</style>

//             <Sidebar
//                 openSidebar={openSidebar}
//                 setOpenSidebar={setOpenSidebar}
//                 openSidebarMobile={openSidebarMobile}
//                 setOpenSidebarMobile={setOpenSidebarMobile}
//             />

//             <div
//                 className={`w-full min-h-screen bg-white flex flex-col transition-all duration-500 ${openSidebar ? "lg:pl-[200px] xl:pl-[260px]" : "lg:pl-16"
//                     }`}
//                 style={{ fontFamily: "Poppins, sans-serif" }}
//             >
//                 {/* ── Top bar ── */}
//                 <div
//                     className="flex items-center xl:px-10 lg:px-9 md:px-8 px-5 border-b border-[#0000001A]"
//                     style={{ height: "88px" }}
//                 >
//                     <button
//                         type="button"
//                         onClick={() => setOpenSidebarMobile(true)}
//                         className="lg:hidden inline-flex items-center justify-center rounded-lg border border-[#0000001A] p-2 text-[#374151]"
//                         aria-label="Open sidebar"
//                     >
//                         <img src={hamburgerIcon} alt="" aria-hidden="true" className="size-5" />
//                     </button>
//                 </div>

//                 {/* ── Page content ── */}
//                 <div className="w-full xl:px-10 lg:px-9 md:px-8 px-5 py-8 flex flex-col gap-6 max-w-screen-xl mx-auto">

//                     {/* ① Main heading */}
//                     <h1
//                         style={{
//                             fontFamily: "Poppins, sans-serif",
//                             fontWeight: 500,
//                             fontSize: "clamp(16px, 1.5vw, 24.68px)",
//                             lineHeight: "100%",
//                             letterSpacing: "-0.99px",
//                             color: "#000000",
//                             margin: 0,
//                         }}
//                     >
//                         {isPro
//                             ? "Manage your account settings and track your usage."
//                             : "Manage your account settings, track your usage, and upgrade your plan to unlock premium features."}
//                     </h1>

//                     {/* ② Time saved */}
//                     {isPro ? (
//                         <div className="flex flex-col gap-0.5">
//                             <p
//                                 style={{
//                                     fontFamily: "Poppins, sans-serif",
//                                     fontWeight: 500,
//                                     fontSize: "clamp(13px, 1.1vw, 15px)",
//                                     color: "#4B5563",
//                                     margin: 0,
//                                 }}
//                             >
//                                 You're on a roll!
//                             </p>
//                             <div className="flex items-baseline gap-3 flex-wrap">
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 700,
//                                         fontSize: "clamp(32px, 4.5vw, 45px)",
//                                         lineHeight: 1,
//                                         color: "#000000",
//                                     }}
//                                 >
//                                     {weeklyTimeSaved.hours}h {weeklyTimeSaved.minutes}m
//                                 </span>
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "clamp(13px, 1.1vw, 16px)",
//                                         color: "#4B5563",
//                                     }}
//                                 >
//                                     Weekly time saved
//                                 </span>
//                             </div>
//                         </div>
//                     ) : (
//                         <div className="flex flex-col gap-1">
//                             <div className="flex items-center justify-between flex-wrap gap-2">
//                                 <div className="flex items-center gap-2">
//                                     <TrendingUp size={15} style={{ color: "#1D9BF0" }} />
//                                     <span
//                                         style={{
//                                             fontFamily: "Poppins, sans-serif",
//                                             fontWeight: 500,
//                                             fontSize: "15px",
//                                             color: "#1D9BF0",
//                                         }}
//                                     >
//                                         Time Saved
//                                     </span>
//                                 </div>
//                                 <button
//                                     className="border border-[#0000001A] rounded-lg px-3 py-1"
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontSize: "12px",
//                                         color: "#374151",
//                                         background: "#FAFAFA",
//                                     }}
//                                 >
//                                     Last 7 days ▾
//                                 </button>
//                             </div>
//                             <div className="flex items-baseline gap-3 flex-wrap">
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 700,
//                                         fontSize: "clamp(32px, 4.5vw, 45px)",
//                                         lineHeight: 1,
//                                         color: "#000000",
//                                     }}
//                                 >
//                                     {weeklyTimeSaved.hours}h {weeklyTimeSaved.minutes}m
//                                 </span>
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "clamp(13px, 1.1vw, 16px)",
//                                         color: "#4B5563",
//                                     }}
//                                 >
//                                     Last 7 days
//                                 </span>
//                             </div>
//                         </div>
//                     )}

//                     {/* ③ Transcription Time card */}
//                     <div
//                         className="w-full flex flex-col gap-4"
//                         style={{
//                             border: "1px solid #0000001A",
//                             borderRadius: "14px",
//                             padding: "20px 22px",
//                             background: "#FAFAFA",
//                         }}
//                     >
//                         {/* Header */}
//                         <div className="flex items-start justify-between gap-2">
//                             <div>
//                                 <p
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 600,
//                                         fontSize: "clamp(14px, 1.2vw, 18px)",
//                                         color: "#000000",
//                                         margin: 0,
//                                         lineHeight: 1.3,
//                                     }}
//                                 >
//                                     Transcription Time
//                                 </p>
//                                 <p
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "13px",
//                                         color: isPro ? "#1D9BF0" : "#6B7280",
//                                         margin: "3px 0 0",
//                                     }}
//                                 >
//                                     {transcription.planLabel}
//                                 </p>
//                             </div>
//                             <TrendingUp size={20} style={{ color: "#1D9BF0", flexShrink: 0 }} />
//                         </div>

//                         {/* Bar */}
//                         <UsageBar used={transcription.used} total={transcription.total} />

//                         {/* Used / Total boxes */}
//                         <div className="flex gap-3 flex-col sm:flex-row">
//                             {[
//                                 {
//                                     label: isPro ? "Used" : "Remaining",
//                                     content: (
//                                         <span
//                                             style={{
//                                                 fontFamily: "Poppins, sans-serif",
//                                                 fontWeight: 600,
//                                                 fontSize: "clamp(15px, 1.4vw, 20px)",
//                                                 color: "#111827",
//                                                 display: "flex",
//                                                 alignItems: "baseline",
//                                                 gap: "4px",
//                                             }}
//                                         >
//                                             {transcription.used}
//                                             <span style={{ fontWeight: 400, fontSize: "14px", color: "#6B7280" }}>min</span>
//                                         </span>
//                                     ),
//                                 },
//                                 {
//                                     label: "Total Limit",
//                                     content: (
//                                         <span
//                                             style={{
//                                                 fontFamily: "Poppins, sans-serif",
//                                                 fontWeight: 600,
//                                                 fontSize: "clamp(15px, 1.4vw, 20px)",
//                                                 color: "#111827",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 gap: "4px",
//                                             }}
//                                         >
//                                             {transcription.total ? (
//                                                 <>
//                                                     {transcription.total}
//                                                     <span style={{ fontWeight: 400, fontSize: "14px", color: "#6B7280" }}>min</span>
//                                                 </>
//                                             ) : (
//                                                 <Infinity size={22} style={{ color: "#111827" }} />
//                                             )}
//                                         </span>
//                                     ),
//                                 },
//                             ].map(({ label, content }) => (
//                                 <div
//                                     key={label}
//                                     className="flex-1"
//                                     style={{
//                                         background: "#EBEBEB",
//                                         borderRadius: "11.81px",
//                                         border: "1.18px solid #DFDFDF",
//                                         paddingTop: "14.17px",
//                                         paddingBottom: "14.17px",
//                                         paddingLeft: "22.11px",
//                                         paddingRight: "22.11px",
//                                     }}
//                                 >
//                                     <p
//                                         style={{
//                                             fontFamily: "Poppins, sans-serif",
//                                             fontWeight: 400,
//                                             fontSize: "14.17px",
//                                             lineHeight: "21.26px",
//                                             color: "#797979",
//                                             margin: "0 0 4px",
//                                         }}
//                                     >
//                                         {label}
//                                     </p>
//                                     {content}
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Footer */}
//                         <div className="flex items-center justify-between flex-wrap gap-1">
//                             <div className="flex items-center gap-1.5">
//                                 <span
//                                     style={{
//                                         width: "8px",
//                                         height: "8px",
//                                         borderRadius: "50%",
//                                         background: "#3AB1F6",
//                                         display: "inline-block",
//                                         flexShrink: 0,
//                                     }}
//                                 />
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
//                                     Used: {transcription.used} min
//                                 </span>
//                             </div>
//                             <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
//                                 Resets: {transcription.resetsOn}
//                             </span>
//                         </div>
//                     </div>

//                     {/* ④ Stat cards – Pro only */}
//                     {isPro && (
//                         <div
//                             className="flex flex-col sm:flex-row"
//                             style={{ gap: "10.58px" }}
//                         >
//                             <StatCard label="Daily Time Saved" value={stats.dailyTimeSaved} icon={Clock} iconBg="#DCFCE7" iconColor="#16A34A" />
//                             <StatCard label="Words Transcribed" value={stats.wordsTranscribed} icon={FileText} iconBg="#DBEAFE" iconColor="#2563EB" />
//                             <StatCard label="Current Streak" value={stats.currentStreak} icon={Flame} iconBg="#FFEDD5" iconColor="#EA580C" />
//                         </div>
//                     )}

//                     {/* ⑤ Device Breakdown */}
//                     <div
//                         className="w-full flex flex-col gap-4"
//                         style={{
//                             border: "1px solid #0000001A",
//                             borderRadius: "14px",
//                             padding: "20px 22px",
//                             background: "#FAFAFA",
//                         }}
//                     >
//                         <p
//                             style={{
//                                 fontFamily: "Poppins, sans-serif",
//                                 fontWeight: 600,
//                                 fontSize: "clamp(14px, 1.2vw, 18px)",
//                                 color: "#000000",
//                                 margin: 0,
//                             }}
//                         >
//                             Device Breakdown — {userName}
//                         </p>

//                         <div className="flex flex-col gap-3">
//                             {devices.map((device) => {
//                                 const pct = (device.audioMin / maxDeviceMin) * 100;
//                                 return (
//                                     <div key={device.name} className="flex flex-col gap-1">
//                                         <div className="flex items-center justify-between">
//                                             <span
//                                                 style={{
//                                                     fontFamily: "Poppins, sans-serif",
//                                                     fontWeight: 500,
//                                                     fontSize: "clamp(12px, 1vw, 14px)",
//                                                     color: "#374151",
//                                                 }}
//                                             >
//                                                 {device.name}
//                                             </span>
//                                             <span
//                                                 style={{
//                                                     fontFamily: "Poppins, sans-serif",
//                                                     fontSize: "12px",
//                                                     color: "#6B7280",
//                                                 }}
//                                             >
//                                                 {device.audioMin} audio min
//                                             </span>
//                                         </div>
//                                         <div
//                                             className="w-full rounded-full overflow-hidden"
//                                             style={{ height: "8px", background: "#E5E7EB" }}
//                                         >
//                                             <div
//                                                 className="h-full rounded-full"
//                                                 style={{
//                                                     width: `${pct}%`,
//                                                     background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
//                                                     transition: "width 0.7s ease",
//                                                 }}
//                                             />
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     </div>

//                     {/* ⑥ Pro / Upgrade banner */}
//                     <div
//                         className="w-full flex flex-col gap-4"
//                         style={{
//                             background: "linear-gradient(135deg, #EBF6FF 0%, #EEF2FF 100%)",
//                             border: "1px solid #C7E4FB",
//                             borderRadius: "14px",
//                             padding: "20px 22px 24px",
//                         }}
//                     >
//                         {/* Title */}
//                         <div className="flex items-center gap-3">
//                             <div
//                                 style={{
//                                     width: "32px",
//                                     height: "32px",
//                                     borderRadius: "8px",
//                                     background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     flexShrink: 0,
//                                 }}
//                             >
//                                 <TrendingUp size={16} color="#fff" strokeWidth={2.5} />
//                             </div>
//                             <span
//                                 style={{
//                                     fontFamily: "Poppins, sans-serif",
//                                     fontWeight: 600,
//                                     fontSize: "clamp(15px, 1.3vw, 20px)",
//                                     color: "#111827",
//                                 }}
//                             >
//                                 {isPro ? "You are on ZT Pro" : "Upgrade to ZT Pro"}
//                             </span>
//                         </div>

//                         {/* Description */}
//                         <p
//                             style={{
//                                 fontFamily: "Poppins, sans-serif",
//                                 fontWeight: 400,
//                                 fontSize: "clamp(12px, 1vw, 14px)",
//                                 color: "#374151",
//                                 margin: 0,
//                             }}
//                         >
//                             {isPro
//                                 ? "Enjoy unlimited transcription, custom prompts, and early access to new releases."
//                                 : "Unlock unlimited transcription and advanced features."}
//                         </p>

//                         {/* Features */}
//                         <div className="grid sm:grid-cols-2 grid-cols-1 gap-x-6 gap-y-2.5">
//                             {PRO_FEATURES.map((f) => (
//                                 <div key={f} className="flex items-center gap-2.5">
//                                     <span
//                                         style={{
//                                             width: "18px",
//                                             height: "18px",
//                                             borderRadius: "50%",
//                                             border: "1.5px solid #1D9BF0",
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             flexShrink: 0,
//                                         }}
//                                     >
//                                         <Check size={10} color="#1D9BF0" strokeWidth={2.8} />
//                                     </span>
//                                     <span
//                                         style={{
//                                             fontFamily: "Poppins, sans-serif",
//                                             fontWeight: 400,
//                                             fontSize: "clamp(12px, 1vw, 14px)",
//                                             color: "#374151",
//                                         }}
//                                     >
//                                         {f}
//                                     </span>
//                                 </div>
//                             ))}
//                         </div>

//                         {/* CTA */}
//                         {isPro ? (
//                             <NavLink
//                                 to="/settings"
//                                 className="flex items-center justify-center gap-2 w-full rounded-xl py-3 mt-1"
//                                 style={{
//                                     background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                     fontFamily: "Poppins, sans-serif",
//                                     fontWeight: 600,
//                                     fontSize: "clamp(13px, 1vw, 15px)",
//                                     color: "#fff",
//                                     textDecoration: "none",
//                                     letterSpacing: "0.01em",
//                                 }}
//                             >
//                                 Manage Subscription <ArrowRight size={16} />
//                             </NavLink>
//                         ) : (
//                             <NavLink
//                                 to="/settings"
//                                 className="flex items-center justify-center w-full rounded-xl py-3 mt-1"
//                                 style={{
//                                     background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                     fontFamily: "Poppins, sans-serif",
//                                     fontWeight: 600,
//                                     fontSize: "clamp(13px, 1vw, 15px)",
//                                     color: "#fff",
//                                     textDecoration: "none",
//                                     letterSpacing: "0.01em",
//                                 }}
//                             >
//                                 Upgrade Now
//                             </NavLink>
//                         )}
//                     </div>

//                     <div style={{ height: "16px" }} />
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Usage;











// import React, { useEffect, useMemo, useState } from "react";
// import { NavLink } from "react-router-dom";
// import {
//     Infinity as InfinityIcon,
//     TrendingUp,
//     ArrowRight,
//     Check,
//     Clock,
//     FileText,
//     Flame,
// } from "lucide-react";
// import Sidebar from "../../component/sidebar/sidebar";
// import hamburgerIcon from "../../Asset/Hamburger.svg";

// // ─── Constants ────────────────────────────────────────────────────────────────
// const PRO_FEATURES = [
//     "Unlimited words per week",
//     "Advanced AI features",
//     "Unlimited audio transcription",
//     "Export in multiple formats",
// ];

// // ─── Helpers ──────────────────────────────────────────────────────────────────

// /** Convert seconds → rounded minutes (1 decimal) */
// const secToMin = (sec) => Math.round((sec / 60) * 10) / 10;

// /** Format a date string → "MMM D" e.g. "Nov 16" */
// const fmtResetDate = (dateStr) => {
//     if (!dateStr) return "—";
//     const d = new Date(dateStr);
//     return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
// };

// // ─── Derive UI state from raw API data ────────────────────────────────────────
// const deriveUsageState = (raw) => {
//     if (!raw) return null;

//     const isPro = String(raw.SubscriptionType || "").trim() === "Pro";

//     // Minutes used from UtilizeSecond
//     const usedMin = secToMin(raw.UtilizeSecond || 0);

//     // Total minutes:
//     //   Pro  → unlimited (null)
//     //   Free → MinuteFree field (e.g. 900 min = 15 h),
//     //          fallback: FreeSecond / 60
//     const totalMin = isPro
//         ? null
//         : raw.MinuteFree > 0
//             ? raw.MinuteFree
//             : secToMin(raw.FreeSecond || 0);

//     // Remaining for free users
//     const remainingMin =
//         totalMin !== null ? Math.max(totalMin - usedMin, 0) : null;

//     const resetsOn = fmtResetDate(raw.EndDate);
//     const planLabel = isPro
//         ? `ZT Pro${raw.SubscriptionPeriod ? ` (${raw.SubscriptionPeriod})` : ""}`
//         : "Free Plan";

//     const balanceDays = raw.BalanceDays ?? null;
//     const endDate = raw.EndDate ? new Date(raw.EndDate) : null;
//     const isActive = String(raw.Status || "").trim() === "Active";

//     return {
//         isPro,
//         isActive,
//         usedMin,
//         totalMin,
//         remainingMin,
//         resetsOn,
//         planLabel,
//         balanceDays,
//         endDate,
//         subscriptionPeriod: raw.SubscriptionPeriod || "",
//     };
// };

// // ─── Stat Card ────────────────────────────────────────────────────────────────
// const StatCard = ({ label, value, icon: Icon, iconBg, iconColor }) => (
//     <div
//         className="flex items-center gap-3 flex-1 min-w-0 bg-white"
//         style={{
//             borderRadius: "12.1px",
//             border: "1.51px solid #0000000D",
//             padding: "0 20px",
//             height: "65px",
//         }}
//     >
//         <div
//             style={{
//                 width: "36px",
//                 height: "36px",
//                 borderRadius: "50%",
//                 background: iconBg,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//             }}
//         >
//             <Icon size={17} color={iconColor} strokeWidth={2.2} />
//         </div>
//         <span
//             style={{
//                 fontFamily: "Poppins, sans-serif",
//                 fontWeight: 500,
//                 fontSize: "18.14px",
//                 lineHeight: "29.48px",
//                 letterSpacing: "-0.14px",
//                 color: "#000000",
//                 whiteSpace: "nowrap",
//             }}
//         >
//             {label}
//         </span>
//         <span
//             className="ml-auto"
//             style={{
//                 fontFamily: "Poppins, sans-serif",
//                 fontWeight: 600,
//                 fontSize: "18.14px",
//                 lineHeight: "31.75px",
//                 letterSpacing: "0.06px",
//                 color: "#000000",
//                 whiteSpace: "nowrap",
//             }}
//         >
//             {value}
//         </span>
//     </div>
// );

// // ─── Progress Bar ─────────────────────────────────────────────────────────────
// const UsageBar = ({ used, total }) => {
//     const pct = total ? Math.min((used / total) * 100, 100) : 100;
//     const isWarning = total && pct >= 80;
//     return (
//         <div
//             className="w-full rounded-full overflow-hidden"
//             style={{ height: "12px", background: "#E5E7EB" }}
//         >
//             <div
//                 className="h-full rounded-full"
//                 style={{
//                     width: `${pct}%`,
//                     background: isWarning
//                         ? "linear-gradient(90deg,#f97316,#ef4444)"
//                         : "linear-gradient(90deg,#3AB1F6,#407BFF)",
//                     transition: "width 0.7s ease",
//                 }}
//             />
//         </div>
//     );
// };

// // ─── Skeleton loader ──────────────────────────────────────────────────────────
// const Skeleton = ({ className = "", style = {} }) => (
//     <div
//         className={`animate-pulse bg-gray-200 rounded-lg ${className}`}
//         style={style}
//     />
// );

// // ─── Main Component ───────────────────────────────────────────────────────────
// const Usage = () => {
//     const [openSidebar, setOpenSidebar] = useState(true);
//     const [openSidebarMobile, setOpenSidebarMobile] = useState(false);

//     // API state
//     const [rawData, setRawData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");

//     const API_BASE = useMemo(
//         () => (process.env.REACT_APP_BACKEND_URL || "http://localhost:5050").replace(/\/$/, ""),
//         []
//     );

//     // ── Fetch subscription info ──────────────────────────────────────────────
//     useEffect(() => {
//         const ctrl = new AbortController();
//         setLoading(true);
//         setError("");

//         (async () => {
//             try {
//                 const res = await fetch(
//                     `${API_BASE}/api/subscription/info`,   // Node BFF route
//                     {
//                         method: "GET",
//                         credentials: "include",             // sends session cookie
//                         signal: ctrl.signal,
//                     }
//                 );

//                 const json = await res.json();

//                 if (!res.ok || !json?.success) {
//                     throw new Error(json?.error || "Failed to load usage data.");
//                 }

//                 // BFF returns { success: true, data: [...] }
//                 const record = Array.isArray(json?.data) ? json.data[0] : null;
//                 setRawData(record || null);
//             } catch (err) {
//                 if (err.name !== "AbortError") setError(err.message);
//             } finally {
//                 setLoading(false);
//             }
//         })();

//         return () => ctrl.abort();
//     }, [API_BASE]);

//     // ── Derive display values ────────────────────────────────────────────────
//     const usage = useMemo(() => deriveUsageState(rawData), [rawData]);

//     // Destructure with safe fallbacks for render
//     const {
//         isPro = false,
//         usedMin = 0,
//         totalMin = null,
//         remainingMin = null,
//         resetsOn = "—",
//         planLabel = "—",
//         balanceDays = null,
//         endDate = null,
//         subscriptionPeriod = "",
//     } = usage || {};

//     // Pro stat cards use derived values from UtilizeSecond
//     // Weekly time saved = usedMin formatted as Xh Ym
//     const totalHours = Math.floor(usedMin / 60);
//     const totalMinutes = Math.round(usedMin % 60);

//     // For free users, display remaining; for pro show used
//     const displayUsed = isPro ? usedMin : (remainingMin ?? usedMin);

//     return (
//         <>
//             <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');`}</style>

//             <Sidebar
//                 openSidebar={openSidebar}
//                 setOpenSidebar={setOpenSidebar}
//                 openSidebarMobile={openSidebarMobile}
//                 setOpenSidebarMobile={setOpenSidebarMobile}
//             />

//             <div
//                 className={`w-full min-h-screen bg-white flex flex-col transition-all duration-500 ${openSidebar ? "lg:pl-[200px] xl:pl-[260px]" : "lg:pl-16"
//                     }`}
//                 style={{ fontFamily: "Poppins, sans-serif" }}
//             >
//                 {/* ── Top bar ── */}
//                 <div
//                     className="flex items-center xl:px-10 lg:px-9 md:px-8 px-5 border-b border-[#0000001A]"
//                     style={{ height: "88px" }}
//                 >
//                     <button
//                         type="button"
//                         onClick={() => setOpenSidebarMobile(true)}
//                         className="lg:hidden inline-flex items-center justify-center rounded-lg border border-[#0000001A] p-2 text-[#374151]"
//                         aria-label="Open sidebar"
//                     >
//                         <img src={hamburgerIcon} alt="" aria-hidden="true" className="size-5" />
//                     </button>
//                 </div>

//                 {/* ── Page content ── */}
//                 <div className="w-full xl:px-10 lg:px-9 md:px-8 px-5 py-8 flex flex-col gap-6 max-w-screen-xl mx-auto">

//                     {/* Error state */}
//                     {error && (
//                         <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-5 py-4 text-sm font-medium">
//                             {error}
//                         </div>
//                     )}

//                     {/* ① Main heading */}
//                     <h1
//                         style={{
//                             fontFamily: "Poppins, sans-serif",
//                             fontWeight: 500,
//                             fontSize: "clamp(16px, 1.5vw, 24.68px)",
//                             lineHeight: "100%",
//                             letterSpacing: "-0.99px",
//                             color: "#000000",
//                             margin: 0,
//                         }}
//                     >
//                         {loading ? (
//                             <Skeleton style={{ height: "28px", width: "60%" }} />
//                         ) : isPro
//                             ? "Manage your account settings and track your usage."
//                             : "Manage your account settings, track your usage, and upgrade your plan to unlock premium features."}
//                     </h1>

//                     {/* ② Time saved */}
//                     {loading ? (
//                         <div className="flex flex-col gap-2">
//                             <Skeleton style={{ height: "18px", width: "120px" }} />
//                             <Skeleton style={{ height: "52px", width: "220px" }} />
//                         </div>
//                     ) : isPro ? (
//                         <div className="flex flex-col gap-0.5">
//                             <p
//                                 style={{
//                                     fontFamily: "Poppins, sans-serif",
//                                     fontWeight: 500,
//                                     fontSize: "clamp(13px, 1.1vw, 15px)",
//                                     color: "#4B5563",
//                                     margin: 0,
//                                 }}
//                             >
//                                 You're on a roll!
//                             </p>
//                             <div className="flex items-baseline gap-3 flex-wrap">
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 700,
//                                         fontSize: "clamp(32px, 4.5vw, 45px)",
//                                         lineHeight: 1,
//                                         color: "#000000",
//                                     }}
//                                 >
//                                     {totalHours > 0
//                                         ? `${totalHours}h ${totalMinutes}m`
//                                         : `${usedMin}m`}
//                                 </span>
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "clamp(13px, 1.1vw, 16px)",
//                                         color: "#4B5563",
//                                     }}
//                                 >
//                                     Weekly time saved
//                                 </span>
//                             </div>
//                         </div>
//                     ) : (
//                         <div className="flex flex-col gap-1">
//                             <div className="flex items-center justify-between flex-wrap gap-2">
//                                 <div className="flex items-center gap-2">
//                                     <TrendingUp size={15} style={{ color: "#1D9BF0" }} />
//                                     <span
//                                         style={{
//                                             fontFamily: "Poppins, sans-serif",
//                                             fontWeight: 500,
//                                             fontSize: "15px",
//                                             color: "#1D9BF0",
//                                         }}
//                                     >
//                                         Time Saved
//                                     </span>
//                                 </div>
//                                 {balanceDays !== null && (
//                                     <span
//                                         className="border border-[#0000001A] rounded-lg px-3 py-1"
//                                         style={{
//                                             fontFamily: "Poppins, sans-serif",
//                                             fontSize: "12px",
//                                             color: "#374151",
//                                             background: "#FAFAFA",
//                                         }}
//                                     >
//                                         Last {balanceDays} days
//                                     </span>
//                                 )}
//                             </div>
//                             <div className="flex items-baseline gap-3 flex-wrap">
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 700,
//                                         fontSize: "clamp(32px, 4.5vw, 45px)",
//                                         lineHeight: 1,
//                                         color: "#000000",
//                                     }}
//                                 >
//                                     {totalHours > 0
//                                         ? `${totalHours}h ${totalMinutes}m`
//                                         : `${usedMin}m`}
//                                 </span>
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "clamp(13px, 1.1vw, 16px)",
//                                         color: "#4B5563",
//                                     }}
//                                 >
//                                     Last {balanceDays ?? 7} days
//                                 </span>
//                             </div>
//                         </div>
//                     )}

//                     {/* ③ Transcription Time card */}
//                     <div
//                         className="w-full flex flex-col gap-4"
//                         style={{
//                             // border: "1px solid #0000001A",
//                             // borderRadius: "14px",
//                             padding: "20px 22px",
//                             // background: "#FAFAFA",
//                         }}
//                     >
//                         {/* Header */}
//                         <div className="flex items-start justify-between gap-2">
//                             <div>
//                                 <p
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 600,
//                                         fontSize: "clamp(14px, 1.2vw, 18px)",
//                                         color: "#000000",
//                                         margin: 0,
//                                         lineHeight: 1.3,
//                                     }}
//                                 >
//                                     Transcription Time
//                                 </p>
//                                 <p
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "13px",
//                                         color: isPro ? "#1D9BF0" : "#6B7280",
//                                         margin: "3px 0 0",
//                                     }}
//                                 >
//                                     {loading ? "—" : planLabel}
//                                 </p>
//                             </div>
//                             <TrendingUp size={20} style={{ color: "#1D9BF0", flexShrink: 0 }} />
//                         </div>

//                         {/* Bar */}
//                         {loading ? (
//                             <Skeleton style={{ height: "12px", borderRadius: "999px" }} />
//                         ) : (
//                             <UsageBar used={usedMin} total={totalMin} />
//                         )}

//                         {/* Used / Total boxes */}
//                         <div className="flex gap-3 flex-col sm:flex-row">
//                             {[
//                                 {
//                                     label: isPro ? "Used" : "Remaining",
//                                     content: loading ? (
//                                         <Skeleton style={{ height: "24px", width: "80px" }} />
//                                     ) : (
//                                         <span
//                                             style={{
//                                                 fontFamily: "Poppins, sans-serif",
//                                                 fontWeight: 600,
//                                                 fontSize: "clamp(15px, 1.4vw, 20px)",
//                                                 color: "#111827",
//                                                 display: "flex",
//                                                 alignItems: "baseline",
//                                                 gap: "4px",
//                                             }}
//                                         >
//                                             {displayUsed}
//                                             <span style={{ fontWeight: 400, fontSize: "14px", color: "#6B7280" }}>
//                                                 min
//                                             </span>
//                                         </span>
//                                     ),
//                                 },
//                                 {
//                                     label: "Total Limit",
//                                     content: loading ? (
//                                         <Skeleton style={{ height: "24px", width: "80px" }} />
//                                     ) : (
//                                         <span
//                                             style={{
//                                                 fontFamily: "Poppins, sans-serif",
//                                                 fontWeight: 600,
//                                                 fontSize: "clamp(15px, 1.4vw, 20px)",
//                                                 color: "#111827",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 gap: "4px",
//                                             }}
//                                         >
//                                             {totalMin ? (
//                                                 <>
//                                                     {totalMin}
//                                                     <span style={{ fontWeight: 400, fontSize: "14px", color: "#6B7280" }}>
//                                                         min
//                                                     </span>
//                                                 </>
//                                             ) : (
//                                                 <InfinityIcon size={22} style={{ color: "#111827" }} />
//                                             )}
//                                         </span>
//                                     ),
//                                 },
//                             ].map(({ label, content }) => (
//                                 <div
//                                     key={label}
//                                     className="flex-1"
//                                     style={{
//                                         background: "#EBEBEB",
//                                         borderRadius: "11.81px",
//                                         border: "1.18px solid #DFDFDF",
//                                         paddingTop: "14.17px",
//                                         paddingBottom: "14.17px",
//                                         paddingLeft: "22.11px",
//                                         paddingRight: "22.11px",
//                                     }}
//                                 >
//                                     <p
//                                         style={{
//                                             fontFamily: "Poppins, sans-serif",
//                                             fontWeight: 400,
//                                             fontSize: "14.17px",
//                                             lineHeight: "21.26px",
//                                             color: "#797979",
//                                             margin: "0 0 4px",
//                                         }}
//                                     >
//                                         {label}
//                                     </p>
//                                     {content}
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Footer */}
//                         <div className="flex items-center justify-between flex-wrap gap-1">
//                             <div className="flex items-center gap-1.5">
//                                 <span
//                                     style={{
//                                         width: "8px",
//                                         height: "8px",
//                                         borderRadius: "50%",
//                                         background: "#3AB1F6",
//                                         display: "inline-block",
//                                         flexShrink: 0,
//                                     }}
//                                 />
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
//                                     Used: {usedMin} min
//                                 </span>
//                             </div>
//                             <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
//                                 Resets: {loading ? "—" : resetsOn}
//                             </span>
//                         </div>
//                     </div>

//                     {/* ④ Stat cards – Pro only */}
//                     {!loading && isPro && (
//                         <div className="flex flex-col sm:flex-row" style={{ gap: "10.58px" }}>
//                             <StatCard
//                                 label="Daily Time Saved"
//                                 value={totalHours > 0 ? `${totalHours}h ${totalMinutes}m` : `${usedMin}m`}
//                                 icon={Clock}
//                                 iconBg="#DCFCE7"
//                                 iconColor="#16A34A"
//                             />
//                             <StatCard
//                                 label="Words Transcribed"
//                                 value={`${Math.round(usedMin * 130 / 1000 * 10) / 10}k`}
//                                 icon={FileText}
//                                 iconBg="#DBEAFE"
//                                 iconColor="#2563EB"
//                             />
//                             <StatCard
//                                 label="Plan Period"
//                                 value={subscriptionPeriod || "—"}
//                                 icon={Flame}
//                                 iconBg="#FFEDD5"
//                                 iconColor="#EA580C"
//                             />
//                         </div>
//                     )}

//                     {/* Loading skeleton for stat cards */}
//                     {loading && (
//                         <div className="flex flex-col sm:flex-row gap-3">
//                             {[1, 2, 3].map((i) => (
//                                 <Skeleton key={i} className="flex-1" style={{ height: "65px" }} />
//                             ))}
//                         </div>
//                     )}

//                     {/* ⑤ Device Breakdown — no live data from this API, keep static structure */}
//                     {/* Remove this section entirely if you have no device data yet */}

//                     {/* ⑥ Pro / Upgrade banner */}
//                     {!loading && (
//                         <div
//                             className="w-full flex flex-col gap-4"
//                             style={{
//                                 background: "linear-gradient(135deg, #EBF6FF 0%, #EEF2FF 100%)",
//                                 border: "1px solid #C7E4FB",
//                                 borderRadius: "14px",
//                                 padding: "20px 22px 24px",
//                             }}
//                         >
//                             {/* Title */}
//                             <div className="flex items-center gap-3">
//                                 <div
//                                     style={{
//                                         width: "32px",
//                                         height: "32px",
//                                         borderRadius: "8px",
//                                         background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         flexShrink: 0,
//                                     }}
//                                 >
//                                     <TrendingUp size={16} color="#fff" strokeWidth={2.5} />
//                                 </div>
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 600,
//                                         fontSize: "clamp(15px, 1.3vw, 20px)",
//                                         color: "#111827",
//                                     }}
//                                 >
//                                     {isPro ? "You are on ZT Pro" : "Upgrade to ZT Pro"}
//                                 </span>
//                             </div>

//                             {/* Description */}
//                             <p
//                                 style={{
//                                     fontFamily: "Poppins, sans-serif",
//                                     fontWeight: 400,
//                                     fontSize: "clamp(12px, 1vw, 14px)",
//                                     color: "#374151",
//                                     margin: 0,
//                                 }}
//                             >
//                                 {isPro
//                                     ? "Enjoy unlimited transcription, custom prompts, and early access to new releases."
//                                     : "Unlock unlimited transcription and advanced features."}
//                             </p>

//                             {/* Features */}
//                             <div className="grid sm:grid-cols-2 grid-cols-1 gap-x-6 gap-y-2.5">
//                                 {PRO_FEATURES.map((f) => (
//                                     <div key={f} className="flex items-center gap-2.5">
//                                         <span
//                                             style={{
//                                                 width: "18px",
//                                                 height: "18px",
//                                                 borderRadius: "50%",
//                                                 border: "1.5px solid #1D9BF0",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 flexShrink: 0,
//                                             }}
//                                         >
//                                             <Check size={10} color="#1D9BF0" strokeWidth={2.8} />
//                                         </span>
//                                         <span
//                                             style={{
//                                                 fontFamily: "Poppins, sans-serif",
//                                                 fontWeight: 400,
//                                                 fontSize: "clamp(12px, 1vw, 14px)",
//                                                 color: "#374151",
//                                             }}
//                                         >
//                                             {f}
//                                         </span>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Expiry info */}
//                             {endDate && (
//                                 <p
//                                     style={{
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontSize: "12px",
//                                         color: "#6B7280",
//                                         margin: 0,
//                                     }}
//                                 >
//                                     {isPro ? "Renews on" : "Resets on"}{" "}
//                                     {endDate.toLocaleDateString("en-US", {
//                                         month: "long",
//                                         day: "numeric",
//                                         year: "numeric",
//                                     })}
//                                 </p>
//                             )}

//                             {/* CTA */}
//                             {isPro ? (
//                                 <NavLink
//                                     to="/app"
//                                     className="flex items-center justify-center gap-2 w-full rounded-xl py-3 mt-1"
//                                     style={{
//                                         background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 600,
//                                         fontSize: "clamp(13px, 1vw, 15px)",
//                                         color: "#fff",
//                                         textDecoration: "none",
//                                         letterSpacing: "0.01em",
//                                     }}
//                                 >
//                                     Go to Dashboard <ArrowRight size={16} />
//                                 </NavLink>
//                             ) : (
//                                 <NavLink
//                                     to="/settings"
//                                     className="flex items-center justify-center w-full rounded-xl py-3 mt-1"
//                                     style={{
//                                         background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                         fontFamily: "Poppins, sans-serif",
//                                         fontWeight: 600,
//                                         fontSize: "clamp(13px, 1vw, 15px)",
//                                         color: "#fff",
//                                         textDecoration: "none",
//                                         letterSpacing: "0.01em",
//                                     }}
//                                 >
//                                     Upgrade Now
//                                 </NavLink>
//                             )}
//                         </div>
//                     )}

//                     <div style={{ height: "16px" }} />
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Usage;





// import React, { useEffect, useMemo, useState } from "react";
// import { NavLink } from "react-router-dom";
// import {
//     Infinity as InfinityIcon,
//     TrendingUp,
//     ArrowRight,
//     Check,
//     Clock,
//     FileText,
//     Flame,
// } from "lucide-react";
// import Sidebar from "../../component/sidebar/sidebar";
// import hamburgerIcon from "../../Asset/Hamburger.svg";

// // ─── Constants ────────────────────────────────────────────────────────────────
// const PRO_FEATURES = [
//     "Unlimited words per week",
//     "Advanced AI features",
//     "Unlimited audio transcription",
//     "Export in multiple formats",
// ];

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const secToMin = (sec) => Math.round((sec / 60) * 10) / 10;

// const fmtResetDate = (dateStr) => {
//     if (!dateStr) return "—";
//     const d = new Date(dateStr);
//     return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
// };

// const deriveUsageState = (raw) => {
//     if (!raw) return null;
//     const isPro = String(raw.SubscriptionType || "").trim() === "Pro";
//     const usedMin = secToMin(raw.UtilizeSecond || 0);
//     const totalMin = isPro
//         ? null
//         : raw.MinuteFree > 0
//             ? raw.MinuteFree
//             : secToMin(raw.FreeSecond || 0);
//     const remainingMin = totalMin !== null ? Math.max(totalMin - usedMin, 0) : null;
//     const resetsOn = fmtResetDate(raw.EndDate);
//     const planLabel = isPro
//         ? `ZT Pro${raw.SubscriptionPeriod ? ` (${raw.SubscriptionPeriod})` : ""}`
//         : "Free Plan";
//     const balanceDays = raw.BalanceDays ?? null;
//     const endDate = raw.EndDate ? new Date(raw.EndDate) : null;
//     const isActive = String(raw.Status || "").trim() === "Active";
//     return {
//         isPro, isActive, usedMin, totalMin, remainingMin,
//         resetsOn, planLabel, balanceDays, endDate,
//         subscriptionPeriod: raw.SubscriptionPeriod || "",
//     };
// };

// // ─── Stat Card ────────────────────────────────────────────────────────────────
// const StatCard = ({ label, value, icon: Icon, iconBg, iconColor }) => (
//     <div
//         className="flex items-center gap-3 w-full bg-white"
//         style={{
//             borderRadius: "12.1px",
//             border: "1.51px solid #0000000D",
//             padding: "12px 16px",
//             minHeight: "65px",
//         }}
//     >
//         <div
//             style={{
//                 width: "36px",
//                 height: "36px",
//                 borderRadius: "50%",
//                 background: iconBg,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//             }}
//         >
//             <Icon size={17} color={iconColor} strokeWidth={2.2} />
//         </div>
//         <span
//             style={{
//                 fontFamily: "Poppins, sans-serif",
//                 fontWeight: 500,
//                 fontSize: "clamp(13px, 1.2vw, 18px)",
//                 lineHeight: 1.4,
//                 letterSpacing: "-0.14px",
//                 color: "#000000",
//                 flex: 1,
//                 minWidth: 0,
//             }}
//         >
//             {label}
//         </span>
//         <span
//             style={{
//                 fontFamily: "Poppins, sans-serif",
//                 fontWeight: 600,
//                 fontSize: "clamp(13px, 1.2vw, 18px)",
//                 lineHeight: 1.4,
//                 letterSpacing: "0.06px",
//                 color: "#000000",
//                 flexShrink: 0,
//             }}
//         >
//             {value}
//         </span>
//     </div>
// );

// // ─── Progress Bar ─────────────────────────────────────────────────────────────
// const UsageBar = ({ used, total }) => {
//     const pct = total ? Math.min((used / total) * 100, 100) : 100;
//     const isWarning = total && pct >= 80;
//     return (
//         <div className="w-full rounded-full overflow-hidden" style={{ height: "12px", background: "#E5E7EB" }}>
//             <div
//                 className="h-full rounded-full"
//                 style={{
//                     width: `${pct}%`,
//                     background: isWarning
//                         ? "linear-gradient(90deg,#f97316,#ef4444)"
//                         : "linear-gradient(90deg,#3AB1F6,#407BFF)",
//                     transition: "width 0.7s ease",
//                 }}
//             />
//         </div>
//     );
// };

// // ─── Skeleton ─────────────────────────────────────────────────────────────────
// const Skeleton = ({ className = "", style = {} }) => (
//     <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} style={style} />
// );

// // ─── Main Component ───────────────────────────────────────────────────────────
// const Usage = () => {
//     const [openSidebar, setOpenSidebar] = useState(true);
//     const [openSidebarMobile, setOpenSidebarMobile] = useState(false);
//     const [rawData, setRawData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");

//     const API_BASE = useMemo(
//         () => (process.env.REACT_APP_BACKEND_URL || "http://localhost:5050").replace(/\/$/, ""),
//         []
//     );

//     useEffect(() => {
//         const ctrl = new AbortController();
//         setLoading(true);
//         setError("");
//         (async () => {
//             try {
//                 const res = await fetch(`${API_BASE}/api/subscription/info`, {
//                     method: "GET",
//                     credentials: "include",
//                     signal: ctrl.signal,
//                 });
//                 const json = await res.json();
//                 if (!res.ok || !json?.success) throw new Error(json?.error || "Failed to load usage data.");
//                 const record = Array.isArray(json?.data) ? json.data[0] : null;
//                 setRawData(record || null);
//             } catch (err) {
//                 if (err.name !== "AbortError") setError(err.message);
//             } finally {
//                 setLoading(false);
//             }
//         })();
//         return () => ctrl.abort();
//     }, [API_BASE]);

//     const usage = useMemo(() => deriveUsageState(rawData), [rawData]);

//     const {
//         isPro = false,
//         usedMin = 0,
//         totalMin = null,
//         remainingMin = null,
//         resetsOn = "—",
//         planLabel = "—",
//         balanceDays = null,
//         endDate = null,
//         subscriptionPeriod = "",
//     } = usage || {};

//     const totalHours = Math.floor(usedMin / 60);
//     const totalMinutes = Math.round(usedMin % 60);
//     const displayUsed = isPro ? usedMin : (remainingMin ?? usedMin);

//     return (
//         <>
//             <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');`}</style>

//             <Sidebar
//                 openSidebar={openSidebar}
//                 setOpenSidebar={setOpenSidebar}
//                 openSidebarMobile={openSidebarMobile}
//                 setOpenSidebarMobile={setOpenSidebarMobile}
//             />

//             <div
//                 className={`w-full min-h-screen bg-white flex flex-col transition-all duration-500 ${openSidebar ? "lg:pl-[200px] xl:pl-[260px]" : "lg:pl-16"
//                     }`}
//                 style={{ fontFamily: "Poppins, sans-serif" }}
//             >
//                 {/* ── Top bar ── */}
//                 <div
//                     className="flex items-center xl:px-10 lg:px-9 md:px-8 px-4 border-b border-[#0000001A]"
//                     style={{ height: "88px" }}
//                 >
//                     <button
//                         type="button"
//                         onClick={() => setOpenSidebarMobile(true)}
//                         className="lg:hidden inline-flex items-center justify-center rounded-lg border border-[#0000001A] p-2 text-[#374151]"
//                         aria-label="Open sidebar"
//                     >
//                         <img src={hamburgerIcon} alt="" aria-hidden="true" className="size-5" />
//                     </button>
//                 </div>

//                 {/* ── Page content ── */}
//                 <div className="w-full xl:px-10 lg:px-9 md:px-8 px-4 py-6 flex flex-col gap-5 max-w-screen-xl mx-auto box-border overflow-hidden">

//                     {/* Error */}
//                     {error && (
//                         <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm font-medium">
//                             {error}
//                         </div>
//                     )}

//                     {/* ① Heading */}
//                     <h1
//                         style={{
//                             fontFamily: "Poppins, sans-serif",
//                             fontWeight: 500,
//                             fontSize: "clamp(14px, 1.5vw, 24.68px)",
//                             lineHeight: "130%",
//                             letterSpacing: "-0.5px",
//                             color: "#000000",
//                             margin: 0,
//                             wordBreak: "break-word",
//                         }}
//                     >
//                         {loading ? (
//                             <Skeleton style={{ height: "24px", width: "70%" }} />
//                         ) : isPro
//                             ? "Manage your account settings and track your usage."
//                             : "Manage your account settings, track your usage, and upgrade your plan to unlock premium features."}
//                     </h1>

//                     {/* ② Time saved */}
//                     {loading ? (
//                         <div className="flex flex-col gap-2">
//                             <Skeleton style={{ height: "16px", width: "100px" }} />
//                             <Skeleton style={{ height: "44px", width: "180px" }} />
//                         </div>
//                     ) : isPro ? (
//                         <div className="flex flex-col gap-0.5">
//                             <div className="flex items-center justify-between flex-wrap gap-2">
//                                 <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: "clamp(12px, 1vw, 15px)", color: "#4B5563", margin: 0 }}>
//                                     You're on a roll!
//                                 </p>
//                                 {balanceDays !== null && (
//                                     <span
//                                         className="border border-[#0000001A] rounded-lg px-3 py-1"
//                                         style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#374151", background: "#FAFAFA" }}
//                                     >
//                                         Last {balanceDays} days ▾
//                                     </span>
//                                 )}
//                             </div>
//                             <div className="flex items-baseline gap-2 flex-wrap">
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 45px)", lineHeight: 1, color: "#000000" }}>
//                                     {totalHours > 0 ? `${totalHours}h ${totalMinutes}m` : `${usedMin}m`}
//                                 </span>
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 16px)", color: "#4B5563" }}>
//                                     Weekly time saved
//                                 </span>
//                             </div>
//                         </div>
//                     ) : (
//                         <div className="flex flex-col gap-1">
//                             <div className="flex items-center justify-between flex-wrap gap-2">
//                                 <div className="flex items-center gap-2">
//                                     <TrendingUp size={14} style={{ color: "#1D9BF0" }} />
//                                     <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: "14px", color: "#1D9BF0" }}>
//                                         Time Saved
//                                     </span>
//                                 </div>
//                                 {balanceDays !== null && (
//                                     <span
//                                         className="border border-[#0000001A] rounded-lg px-3 py-1"
//                                         style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#374151", background: "#FAFAFA" }}
//                                     >
//                                         Last {balanceDays} days
//                                     </span>
//                                 )}
//                             </div>
//                             <div className="flex items-baseline gap-2 flex-wrap">
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 45px)", lineHeight: 1, color: "#000000" }}>
//                                     {totalHours > 0 ? `${totalHours}h ${totalMinutes}m` : `${usedMin}m`}
//                                 </span>
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 16px)", color: "#4B5563" }}>
//                                     Last {balanceDays ?? 7} days
//                                 </span>
//                             </div>
//                         </div>
//                     )}

//                     {/* ③ Transcription Time card */}
//                     <div
//                         className="w-full flex flex-col gap-4 box-border"
//                         style={{
//                             border: "1px solid #0000001A",
//                             borderRadius: "14px",
//                             padding: "16px",
//                             background: "#FAFAFA",
//                         }}
//                     >
//                         {/* Header */}
//                         <div className="flex items-start justify-between gap-2">
//                             <div>
//                                 <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(14px, 1.2vw, 18px)", color: "#000000", margin: 0, lineHeight: 1.3 }}>
//                                     Transcription Time
//                                 </p>
//                                 <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "13px", color: isPro ? "#1D9BF0" : "#6B7280", margin: "3px 0 0" }}>
//                                     {loading ? "—" : planLabel}
//                                 </p>
//                             </div>
//                             <TrendingUp size={18} style={{ color: "#1D9BF0", flexShrink: 0 }} />
//                         </div>

//                         {/* Bar */}
//                         {loading ? (
//                             <Skeleton style={{ height: "12px", borderRadius: "999px" }} />
//                         ) : (
//                             <UsageBar used={usedMin} total={totalMin} />
//                         )}

//                         {/* Used / Total boxes — always stacked on mobile */}
//                         <div className="flex flex-col gap-3">
//                             {[
//                                 {
//                                     label: isPro ? "Used" : "Remaining",
//                                     content: loading ? (
//                                         <Skeleton style={{ height: "24px", width: "80px" }} />
//                                     ) : (
//                                         <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(14px, 1.4vw, 20px)", color: "#111827", display: "flex", alignItems: "baseline", gap: "4px" }}>
//                                             {displayUsed}
//                                             <span style={{ fontWeight: 400, fontSize: "13px", color: "#6B7280" }}>min</span>
//                                         </span>
//                                     ),
//                                 },
//                                 {
//                                     label: "Total Limit",
//                                     content: loading ? (
//                                         <Skeleton style={{ height: "24px", width: "80px" }} />
//                                     ) : (
//                                         <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(14px, 1.4vw, 20px)", color: "#111827", display: "flex", alignItems: "center", gap: "4px" }}>
//                                             {totalMin ? (
//                                                 <>{totalMin}<span style={{ fontWeight: 400, fontSize: "13px", color: "#6B7280" }}>min</span></>
//                                             ) : (
//                                                 <InfinityIcon size={20} style={{ color: "#111827" }} />
//                                             )}
//                                         </span>
//                                     ),
//                                 },
//                             ].map(({ label, content }) => (
//                                 <div
//                                     key={label}
//                                     className="flex items-center justify-between w-full box-border"
//                                     style={{
//                                         background: "#EBEBEB",
//                                         borderRadius: "11.81px",
//                                         border: "1.18px solid #DFDFDF",
//                                         padding: "12px 18px",
//                                     }}
//                                 >
//                                     <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "14px", color: "#797979", margin: 0 }}>
//                                         {label}
//                                     </p>
//                                     {content}
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Footer */}
//                         <div className="flex items-center justify-between flex-wrap gap-1">
//                             <div className="flex items-center gap-1.5">
//                                 <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#3AB1F6", display: "inline-block", flexShrink: 0 }} />
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
//                                     Used: {usedMin} min
//                                 </span>
//                             </div>
//                             <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
//                                 Resets: {loading ? "—" : resetsOn}
//                             </span>
//                         </div>
//                     </div>

//                     {/* ④ Stat cards – Pro only, stacked vertically */}
//                     {!loading && isPro && (
//                         <div className="flex flex-col gap-3">
//                             <StatCard
//                                 label="Daily Time Saved"
//                                 value={totalHours > 0 ? `${totalHours}h ${totalMinutes}m` : `${usedMin}m`}
//                                 icon={Clock}
//                                 iconBg="#DCFCE7"
//                                 iconColor="#16A34A"
//                             />
//                             <StatCard
//                                 label="Words Transcribed"
//                                 value={`${Math.round(usedMin * 130 / 1000 * 10) / 10}k`}
//                                 icon={FileText}
//                                 iconBg="#DBEAFE"
//                                 iconColor="#2563EB"
//                             />
//                             <StatCard
//                                 label="Current Streak"
//                                 value={subscriptionPeriod || "—"}
//                                 icon={Flame}
//                                 iconBg="#FFEDD5"
//                                 iconColor="#EA580C"
//                             />
//                         </div>
//                     )}

//                     {/* Loading skeleton for stat cards */}
//                     {loading && (
//                         <div className="flex flex-col gap-3">
//                             {[1, 2, 3].map((i) => (
//                                 <Skeleton key={i} style={{ height: "65px", width: "100%" }} />
//                             ))}
//                         </div>
//                     )}

//                     {/* ⑥ Pro / Upgrade banner */}
//                     {!loading && (
//                         <div
//                             className="w-full flex flex-col gap-4 box-border"
//                             style={{
//                                 background: "linear-gradient(135deg, #EBF6FF 0%, #EEF2FF 100%)",
//                                 border: "1px solid #C7E4FB",
//                                 borderRadius: "14px",
//                                 padding: "16px 16px 20px",
//                             }}
//                         >
//                             {/* Title */}
//                             <div className="flex items-center gap-3">
//                                 <div
//                                     style={{
//                                         width: "32px", height: "32px", borderRadius: "8px",
//                                         background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                         display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
//                                     }}
//                                 >
//                                     <TrendingUp size={16} color="#fff" strokeWidth={2.5} />
//                                 </div>
//                                 <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(15px, 1.3vw, 20px)", color: "#111827" }}>
//                                     {isPro ? "You are on ZT Pro" : "Upgrade to ZT Pro"}
//                                 </span>
//                             </div>

//                             {/* Description */}
//                             <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 14px)", color: "#374151", margin: 0, lineHeight: 1.6 }}>
//                                 {isPro
//                                     ? "Enjoy unlimited transcription, custom prompts, and early access to new releases."
//                                     : "Unlock unlimited transcription and advanced features."}
//                             </p>

//                             {/* Features */}
//                             <div className="flex flex-col gap-2">
//                                 {PRO_FEATURES.map((f) => (
//                                     <div key={f} className="flex items-center gap-2.5">
//                                         <Check size={14} color="#1D9BF0" strokeWidth={2.8} style={{ flexShrink: 0 }} />
//                                         <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 14px)", color: "#374151" }}>
//                                             {f}
//                                         </span>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Expiry */}
//                             {endDate && (
//                                 <p style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280", margin: 0 }}>
//                                     {isPro ? "Renews on" : "Resets on"}{" "}
//                                     {endDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
//                                 </p>
//                             )}

//                             {/* CTA */}
//                             {isPro ? (
//                                 <NavLink
//                                     to="/app"
//                                     className="flex items-center justify-center gap-2 w-full rounded-xl py-3"
//                                     style={{
//                                         background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                         fontFamily: "Poppins, sans-serif", fontWeight: 600,
//                                         fontSize: "clamp(13px, 1vw, 15px)", color: "#fff",
//                                         textDecoration: "none", letterSpacing: "0.01em",
//                                     }}
//                                 >
//                                     Go to Dashboard <ArrowRight size={16} />
//                                 </NavLink>
//                             ) : (
//                                 <NavLink
//                                     to="/settings"
//                                     className="flex items-center justify-center w-full rounded-xl py-3"
//                                     style={{
//                                         background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
//                                         fontFamily: "Poppins, sans-serif", fontWeight: 600,
//                                         fontSize: "clamp(13px, 1vw, 15px)", color: "#fff",
//                                         textDecoration: "none", letterSpacing: "0.01em",
//                                     }}
//                                 >
//                                     Upgrade Now
//                                 </NavLink>
//                             )}
//                         </div>
//                     )}

//                     <div style={{ height: "16px" }} />
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Usage;






import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import {
    Infinity as InfinityIcon,
    TrendingUp,
    ArrowRight,
    Check,
    Clock,
    FileText,
    Flame,
} from "lucide-react";
import Sidebar from "../../component/sidebar/sidebar";
import AppTopBar from "../../component/AppTopBar/AppTopBar";
import { useUsage } from "../../context/UsageContext";

// ─── Constants ────────────────────────────────────────────────────────────────
const PRO_FEATURES = [
    "Unlimited words per week",
    "Advanced AI features",
    "Unlimited audio transcription",
    "Export in multiple formats",
];

// ─── Static device data (replace with API later) ──────────────────────────
const devices = [
    { name: "Android", audioMin: 45.6 },
    { name: "Web", audioMin: 35.1 },
    { name: "Windows", audioMin: 8.8 },
    { name: "iOS", audioMin: 0.9 },
];
const maxDeviceMin = Math.max(...devices.map((d) => d.audioMin), 1);
// ─── Helpers ──────────────────────────────────────────────────────────────────
const secToMin = (sec) => Math.round((sec / 60) * 10) / 10;

const fmtResetDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const deriveUsageState = (raw) => {
    if (!raw) return null;
    const isPro = String(raw.SubscriptionType || "").trim() === "Pro";
    const usedMin = secToMin(raw.UtilizeSecond || 0);
    const totalMin = isPro
        ? null
        : raw.MinuteFree > 0
            ? raw.MinuteFree
            : secToMin(raw.FreeSecond || 0);
    const remainingMin = totalMin !== null ? Math.max(totalMin - usedMin, 0) : null;
    const resetsOn = fmtResetDate(raw.EndDate);
    const planLabel = isPro
        ? `ZT Pro${raw.SubscriptionPeriod ? ` (${raw.SubscriptionPeriod})` : ""}`
        : "Free Plan";
    const balanceDays = raw.BalanceDays ?? null;
    const endDate = raw.EndDate ? new Date(raw.EndDate) : null;
    const isActive = String(raw.Status || "").trim() === "Active";
    return {
        isPro, isActive, usedMin, totalMin, remainingMin,
        resetsOn, planLabel, balanceDays, endDate,
        subscriptionPeriod: raw.SubscriptionPeriod || "",
    };
};

// ─── Stat Card ────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, icon: Icon, iconBg, iconColor }) => (
    <div
        className="flex items-center gap-3 flex-1 min-w-0 bg-white"
        style={{
            borderRadius: "12.1px",
            border: "1.51px solid #0000000D",
            padding: "12px 16px",
            minHeight: "65px",
        }}
    >
        <div
            style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                background: iconBg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }}
        >
            <Icon size={17} color={iconColor} strokeWidth={2.2} />
        </div>
        <span
            style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 500,
                fontSize: "clamp(12px, 1.1vw, 18px)",
                lineHeight: 1.4,
                letterSpacing: "-0.14px",
                color: "#000000",
                flex: 1,
                minWidth: 0,
            }}
        >
            {label}
        </span>
        <span
            style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: "clamp(12px, 1.1vw, 18px)",
                lineHeight: 1.4,
                letterSpacing: "0.06px",
                color: "#000000",
                flexShrink: 0,
            }}
        >
            {value}
        </span>
    </div>
);

// ─── Progress Bar ─────────────────────────────────────────────────────────────
const UsageBar = ({ used, total }) => {
    const pct = total ? Math.min((used / total) * 100, 100) : 100;
    const isWarning = total && pct >= 80;
    return (
        <div className="w-full rounded-full overflow-hidden" style={{ height: "12px", background: "#E5E7EB" }}>
            <div
                className="h-full rounded-full"
                style={{
                    width: `${pct}%`,
                    background: isWarning
                        ? "linear-gradient(90deg,#f97316,#ef4444)"
                        : "linear-gradient(90deg,#3AB1F6,#407BFF)",
                    transition: "width 0.7s ease",
                }}
            />
        </div>
    );
};

// ─── Skeleton ─────────────────────────────────────────────────────────────────
const Skeleton = ({ className = "", style = {} }) => (
    <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} style={style} />
);

// ─── Main Component ───────────────────────────────────────────────────────────
const Usage = () => {
    const [openSidebar, setOpenSidebar] = useState(true);
    const [openSidebarMobile, setOpenSidebarMobile] = useState(false);
    const { raw: rawData, loading, error, refresh } = useUsage();

    useEffect(() => {
        refresh();
    }, [refresh]);

    const usage = useMemo(() => deriveUsageState(rawData), [rawData]);

    const {
        isPro = false,
        usedMin = 0,
        totalMin = null,
        remainingMin = null,
        resetsOn = "—",
        planLabel = "—",
        balanceDays = null,
        endDate = null,
        subscriptionPeriod = "",
    } = usage || {};

    const totalHours = Math.floor(usedMin / 60);
    const totalMinutes = Math.round(usedMin % 60);
    const displayUsed = isPro ? usedMin : (remainingMin ?? usedMin);

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');`}</style>

            <Sidebar
                openSidebar={openSidebar}
                setOpenSidebar={setOpenSidebar}
                openSidebarMobile={openSidebarMobile}
                setOpenSidebarMobile={setOpenSidebarMobile}
            />

            <div
                className={`w-full min-h-screen bg-white flex flex-col transition-all duration-500 ${openSidebar ? "lg:pl-[200px] xl:pl-[260px]" : "lg:pl-16"
                    }`}
                style={{ fontFamily: "Poppins, sans-serif" }}
            >
                <AppTopBar onOpenSidebar={() => setOpenSidebarMobile(true)} />

                {/* ── Page content ── */}
                <div className="w-full xl:px-10 lg:px-9 md:px-8 px-4 py-6 flex flex-col gap-5 max-w-screen-xl mx-auto box-border overflow-hidden">

                    {/* Error */}
                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm font-medium">
                            {error}
                        </div>
                    )}

                    {/* ① Heading */}
                    <h1
                        style={{
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 500,
                            fontSize: "clamp(14px, 1.5vw, 24.68px)",
                            lineHeight: "130%",
                            letterSpacing: "-0.5px",
                            color: "#000000",
                            margin: 0,
                            wordBreak: "break-word",
                        }}
                    >
                        {loading ? (
                            <Skeleton style={{ height: "24px", width: "70%" }} />
                        ) : isPro
                            ? "Manage your account settings and track your usage."
                            : "Manage your account settings, track your usage, and upgrade your plan to unlock premium features."}
                    </h1>

                    {/* ② Time saved */}
                    {loading ? (
                        <div className="flex flex-col gap-2">
                            <Skeleton style={{ height: "16px", width: "100px" }} />
                            <Skeleton style={{ height: "44px", width: "180px" }} />
                        </div>
                    ) : isPro ? (
                        <div className="flex flex-col gap-0.5">
                            <div className="flex items-center justify-between flex-wrap gap-2">
                                <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: "clamp(12px, 1vw, 15px)", color: "#4B5563", margin: 0 }}>
                                    You're on a roll!
                                </p>
                                {balanceDays !== null && (
                                    <span
                                        className="border border-[#0000001A] rounded-lg px-3 py-1"
                                        style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#374151", background: "#FAFAFA" }}
                                    >
                                        Last {balanceDays} days ▾
                                    </span>
                                )}
                            </div>
                            <div className="flex items-baseline gap-2 flex-wrap">
                                <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 45px)", lineHeight: 1, color: "#000000" }}>
                                    {totalHours > 0 ? `${totalHours}h ${totalMinutes}m` : `${usedMin}m`}
                                </span>
                                {/* <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 16px)", color: "#4B5563" }}>
                                    Weekly time saved
                                </span> */}
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-1">
                            {/* <div className="flex items-center justify-between flex-wrap gap-2">
                                <div className="flex items-center gap-2">
                                    <TrendingUp size={14} style={{ color: "#1D9BF0" }} />
                                    <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: "14px", color: "#1D9BF0" }}>
                                        Time Saved
                                    </span>
                                </div>
                                {balanceDays !== null && (
                                    <span
                                        className="border border-[#0000001A] rounded-lg px-3 py-1"
                                        style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#374151", background: "#FAFAFA" }}
                                    >
                                        Last {balanceDays} days
                                    </span>
                                )}
                            </div> */}
                            <div className="flex items-center justify-between flex-wrap gap-2">
                                <div className="flex items-baseline gap-2 flex-wrap">
                                    <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 45px)", lineHeight: 1, color: "#000000" }}>
                                        {totalHours > 0 ? `${totalHours}h ${totalMinutes}m` : `${usedMin}m`}
                                    </span>
                                    <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 16px)", color: "#4B5563" }}>
                                        Last {balanceDays ?? 7} days
                                    </span>
                                </div>
                                {balanceDays !== null && (
                                    <span
                                        className="border border-[#0000001A] rounded-lg px-3 py-1"
                                        style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#374151", background: "#FAFAFA" }}
                                    >
                                        Last {balanceDays} days
                                    </span>
                                )}
                            </div>

                        </div>
                    )}

                    {/* ③ Transcription Time card */}
                    <div
                        className="w-full flex flex-col gap-4 box-border"
                        style={{
                            // border: "1px solid #0000001A",
                            // borderRadius: "14px",
                            // padding: "16px",
                            // background: "#FAFAFA",
                        }}
                    >
                        {/* Header */}
                        <div className="flex items-start justify-between gap-2">
                            <div>
                                <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(14px, 1.2vw, 18px)", color: "#000000", margin: 0, lineHeight: 1.3 }}>
                                    Transcription Time
                                </p>
                                <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "13px", color: isPro ? "#1D9BF0" : "#6B7280", margin: "3px 0 0" }}>
                                    {loading ? "—" : planLabel}
                                </p>
                            </div>
                            <TrendingUp size={18} style={{ color: "#1D9BF0", flexShrink: 0 }} />
                        </div>

                        {/* Bar */}
                        {loading ? (
                            <Skeleton style={{ height: "12px", borderRadius: "999px" }} />
                        ) : (
                            <UsageBar used={usedMin} total={totalMin} />
                        )}

                        {/* Used / Total boxes — row on desktop, col on mobile */}
                        <div className="flex flex-col sm:flex-row gap-3">
                            {[
                                {
                                    label: isPro ? "Used" : "Remaining",
                                    content: loading ? (
                                        <Skeleton style={{ height: "24px", width: "80px" }} />
                                    ) : (
                                        <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(14px, 1.4vw, 20px)", color: "#111827", display: "flex", alignItems: "baseline", gap: "4px" }}>
                                            {displayUsed}
                                            <span style={{ fontWeight: 400, fontSize: "13px", color: "#6B7280" }}>min</span>
                                        </span>
                                    ),
                                },
                                {
                                    label: "Total Limit",
                                    content: loading ? (
                                        <Skeleton style={{ height: "24px", width: "80px" }} />
                                    ) : (
                                        <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(14px, 1.4vw, 20px)", color: "#111827", display: "flex", alignItems: "center", gap: "4px" }}>
                                            {totalMin ? (
                                                <>{totalMin}<span style={{ fontWeight: 400, fontSize: "13px", color: "#6B7280" }}>min</span></>
                                            ) : (
                                                <InfinityIcon size={20} style={{ color: "#111827" }} />
                                            )}
                                        </span>
                                    ),
                                },
                            ].map(({ label, content }) => (
                                <div
                                    key={label}
                                    className="flex-1 box-border"
                                    style={{
                                        background: "#EBEBEB",
                                        borderRadius: "11.81px",
                                        border: "1.18px solid #DFDFDF",
                                        paddingTop: "14.17px",
                                        paddingBottom: "14.17px",
                                        paddingLeft: "18px",
                                        paddingRight: "18px",
                                    }}
                                >
                                    <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "14px", lineHeight: "21px", color: "#797979", margin: "0 0 4px" }}>
                                        {label}
                                    </p>
                                    {content}
                                </div>
                            ))}
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between flex-wrap gap-1">
                            <div className="flex items-center gap-1.5">
                                <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#3AB1F6", display: "inline-block", flexShrink: 0 }} />
                                <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
                                    Used: {usedMin} min
                                </span>
                            </div>
                            <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280" }}>
                                Resets: {loading ? "—" : resetsOn}
                            </span>
                        </div>
                    </div>

                    {/* ④ Stat cards — row on desktop, col on mobile */}
                    {!loading && isPro && (
                        <div className="flex flex-col sm:flex-row gap-3">
                            <StatCard
                                label="Daily Time Saved"
                                // value={totalHours > 0 ? `${totalHours}h ${totalMinutes}m` : `${usedMin}m`}
                                value="--"
                                icon={Clock}
                                iconBg="#DCFCE7"
                                iconColor="#16A34A"
                            />
                            <StatCard
                                label="Words Transcribed"
                                // value={`${Math.round(usedMin * 130 / 1000 * 10) / 10}k`}
                                value="--"
                                icon={FileText}
                                iconBg="#DBEAFE"
                                iconColor="#2563EB"
                            />
                            <StatCard
                                label="Current Streak"
                                // value={subscriptionPeriod || "—"}
                                value="--"
                                icon={Flame}
                                iconBg="#FFEDD5"
                                iconColor="#EA580C"
                            />
                        </div>
                    )}

                    {/* Loading skeleton for stat cards */}
                    {loading && (
                        <div className="flex flex-col sm:flex-row gap-3">
                            {[1, 2, 3].map((i) => (
                                <Skeleton key={i} className="flex-1" style={{ height: "65px" }} />
                            ))}
                        </div>
                    )}






                    {/* ⑤ Device Breakdown */}
                    {/* <div
                        className="w-full flex flex-col gap-4"
                        style={{
                            border: "1px solid #0000001A",
                            borderRadius: "14px",
                            padding: "20px 22px",
                            background: "#FAFAFA",
                        }}
                    >
                        <p
                            style={{
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: 600,
                                fontSize: "clamp(14px, 1.2vw, 18px)",
                                color: "#000000",
                                margin: 0,
                            }}
                        >
                            Device Breakdown — {devices[0]?.name ?? ""}
                        </p>

                        <div className="flex flex-col gap-3">
                            {devices.map((device) => {
                                const pct = (device.audioMin / maxDeviceMin) * 100;
                                return (
                                    <div key={device.name} className="flex flex-col gap-1">
                                        <div className="flex items-center justify-between">
                                            <span
                                                style={{
                                                    fontFamily: "Poppins, sans-serif",
                                                    fontWeight: 500,
                                                    fontSize: "clamp(12px, 1vw, 14px)",
                                                    color: "#374151",
                                                }}
                                            >
                                                {device.name}
                                            </span>
                                            <span
                                                style={{
                                                    fontFamily: "Poppins, sans-serif",
                                                    fontSize: "12px",
                                                    color: "#6B7280",
                                                }}
                                            >
                                                {device.audioMin} audio min
                                            </span>
                                        </div>
                                        <div
                                            className="w-full rounded-full overflow-hidden"
                                            style={{ height: "8px", background: "#E5E7EB" }}
                                        >
                                            <div
                                                className="h-full rounded-full"
                                                style={{
                                                    width: `${pct}%`,
                                                    background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
                                                    transition: "width 0.7s ease",
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div> */}






                    {/* ⑥ Pro / Upgrade banner */}
                    {!loading && (
                        <div
                            className="w-full flex flex-col gap-4 box-border"
                            style={{
                                background: "linear-gradient(135deg, #EBF6FF 0%, #EEF2FF 100%)",
                                border: "1px solid #C7E4FB",
                                borderRadius: "14px",
                                padding: "16px 16px 20px",
                            }}
                        >
                            {/* Title */}
                            <div className="flex items-center gap-3">
                                <div
                                    style={{
                                        width: "32px", height: "32px", borderRadius: "8px",
                                        background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
                                        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                    }}
                                >
                                    <TrendingUp size={16} color="#fff" strokeWidth={2.5} />
                                </div>
                                <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "clamp(15px, 1.3vw, 20px)", color: "#111827" }}>
                                    {isPro ? "You are on ZT Pro" : "Upgrade to ZT Pro"}
                                </span>
                            </div>

                            {/* Description */}
                            <p style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 14px)", color: "#374151", margin: 0, lineHeight: 1.6 }}>
                                {isPro
                                    ? "Enjoy unlimited transcription, custom prompts, and early access to new releases."
                                    : "Unlock unlimited transcription and advanced features."}
                            </p>

                            {/* Features — 2 col on desktop, 1 col on mobile */}
                            <div className="grid sm:grid-cols-2 grid-cols-1 gap-x-6 gap-y-2">
                                {PRO_FEATURES.map((f) => (
                                    <div key={f} className="flex items-center gap-2.5">
                                        <Check size={14} color="#1D9BF0" strokeWidth={2.8} style={{ flexShrink: 0 }} />
                                        <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 1vw, 14px)", color: "#374151" }}>
                                            {f}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            {/* Expiry */}
                            {endDate && (
                                <p style={{ fontFamily: "Poppins, sans-serif", fontSize: "12px", color: "#6B7280", margin: 0 }}>
                                    {isPro ? "Renews on" : "Resets on"}{" "}
                                    {endDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                                </p>
                            )}

                            {/* CTA */}
                            {isPro ? (
                                <NavLink
                                    to="/settings"
                                    className="flex items-center justify-center gap-2 w-full rounded-xl py-3"
                                    style={{
                                        background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
                                        fontFamily: "Poppins, sans-serif", fontWeight: 600,
                                        fontSize: "clamp(13px, 1vw, 15px)", color: "#fff",
                                        textDecoration: "none", letterSpacing: "0.01em",
                                    }}
                                >
                                    Manage Subscription <ArrowRight size={16} />
                                </NavLink>
                            ) : (
                                <NavLink
                                    to="/settings"
                                    className="flex items-center justify-center w-full rounded-xl py-3"
                                    style={{
                                        background: "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
                                        fontFamily: "Poppins, sans-serif", fontWeight: 600,
                                        fontSize: "clamp(13px, 1vw, 15px)", color: "#fff",
                                        textDecoration: "none", letterSpacing: "0.01em",
                                    }}
                                >
                                    Upgrade Now
                                </NavLink>
                            )}
                        </div>
                    )}

                    <div style={{ height: "16px" }} />
                </div>
            </div>
        </>
    );
};

export default Usage;